import AMCFundDataRender from "./fund_render";

class AMCFundSorter {
    /**
     * @param {Set} fundSet - The fund data set
     * @param {Element} containerElement - The container DOM element
     * @param {AMCFundDataRender} renderer - The renderer instance
     * @param {Function} onSortChange - Callback function called when sort changes, receives (orderItem, isAsc)
     */
    constructor(fundSet, containerElement, renderer, onSortChange) {
        this.fundSet = fundSet;
        this.$container = $(containerElement);
        this.$rootEl = this.$container.find(".camc-fund-list");
        this.$filter = this.$container.find(".camc-fund-list-filter");
        this.renderer = renderer;
        this.onSortChange = onSortChange || (() => {});
        this.currentOrderItem = null;
        this.currentIsAsc = true;
        this.removeSortClass = "sorting sorting_asc sorting_desc";
        this.addDefaultSortClass = "sorting";
        this.bindEvents();
    }

    updateData(data) {
        this.fundSet = data;
    }

    bindEvents() {
        const _this = this;

        // Desktop and tablet sort option change
        _this.$rootEl.find("table thead .sort-header[sort-title]").on("click", (event) => {
            const { sortTitle, sortIsAsc } = _this.updateTableHead(event.target);
            _this.currentOrderItem = sortTitle;
            _this.currentIsAsc = sortIsAsc;
            _this.fundSet = _this.sortHandler(_this.fundSet, sortTitle, "legalName", sortIsAsc);
            _this.activeMobileSorter(sortTitle, sortIsAsc);
            // Notify parent controller
            _this.onSortChange(sortTitle, sortIsAsc);
        });

        // Mobile sort select option change
        _this.$filter.find(".camc-fund-list-filter__panel #name-input-title").change(function () {
            const orderItem = $(this).val();
            if (orderItem) {
                _this.currentOrderItem = orderItem;
                _this.currentIsAsc = false; // Default to descending when changing sort field
                _this.fundSet = _this.sortHandler(_this.fundSet, orderItem, "legalName", false);
                _this.activeMobileSorter(orderItem, false);
                _this.updateTableHead(`.sort-header[sort-title=${orderItem}]`);
                // Notify parent controller
                _this.onSortChange(orderItem, false);
            }
        });

        // Mobile sort order change
        _this.$filter.find(".sort-order-selector input[type=radio]").change(function () {
            const orderItem = _this.$filter.find(".camc-fund-list-filter__panel #name-input-title").val();
            const isAsc = this.value === "Ascending";
            _this.currentIsAsc = isAsc;
            _this.fundSet = _this.sortHandler(_this.fundSet, orderItem, "legalName", isAsc);
            _this.updateTableHead(`.sort-header[sort-title=${orderItem}]`);
            // Notify parent controller
            _this.onSortChange(orderItem, isAsc);
        });
    }

    initTableHead(orderItem, isAsc = false) {
        if (orderItem) {
            const $target = this.$rootEl.find(`table thead .sort-header[sort-title=${orderItem}]`);
            if ($target.hasClass("sorting")) {
                if (isAsc) {
                    $target.removeClass("sorting").addClass("sorting_asc");
                } else {
                    $target.removeClass("sorting").addClass("sorting_desc");
                }
            }
            this.activeMobileSorter(orderItem, isAsc);
        }
    }

    resetTableHead() {
        this.$rootEl
            .find("table thead .sort-header[sort-title]")
            .removeClass(this.removeSortClass)
            .addClass(this.addDefaultSortClass);
    }

    activeMobileSorter(orderItem, option) {
        if (orderItem) this.$filter.find(".camc-fund-list-filter__panel #name-input-title").val(orderItem);
        this.$filter.find(".sort-order-selector input[type=radio]").prop("disabled", false);
        this.$filter
            .find(`.sort-order-selector input[type=radio]#${option ? "ascending" : "descending"}`)
            .prop("checked", true);
    }

    updateTableHead(target) {
        const sortTitle = $(target).attr("sort-title");
        let sortIsAsc = true;

        let targetSortClass = "sorting";
        if ($(target).hasClass("sorting") || $(target).hasClass("sorting_asc")) {
            sortIsAsc = false;
            targetSortClass = "sorting_desc";
        } else if ($(target).hasClass("sorting_desc") != -1) {
            sortIsAsc = true;
            targetSortClass = "sorting_asc";
        }

        this.resetTableHead();
        $(target).removeClass(this.removeSortClass).addClass(targetSortClass);
        return {
            sortTitle,
            sortIsAsc,
        };
    }

    formatString(string, reg) {
        return (string || "").replace(reg, "");
    }

    sortHandler(fundSet, sortTitle, secondSortTitle, isAsc = true) {
        const commaReg = /%/g;
        let defaultNumber;
        const result = [...fundSet].sort((targetObj, compareObj) => {
            if (!isAsc) {
                [targetObj, compareObj] = [compareObj, targetObj];
                defaultNumber = Number.MIN_SAFE_INTEGER;
            } else {
                defaultNumber = Number.MAX_SAFE_INTEGER;
            }
            let target = this.formatString(targetObj[sortTitle], commaReg);
            let compare = this.formatString(compareObj[sortTitle], commaReg);
            if (!isNaN(Number(target)) && !isNaN(Number(compare))) {
                target = !target ? defaultNumber : Number(target);
                compare = !compare ? defaultNumber : Number(compare);
                if (target - compare == 0) {
                    target = this.formatString(targetObj[secondSortTitle], commaReg);
                    compare = this.formatString(compareObj[secondSortTitle], commaReg);
                    return isAsc ? target.localeCompare(compare, "zh-CN") : compare.localeCompare(target, "zh-CN");
                } else {
                    return target - compare;
                }
            } else {
                if (target.localeCompare(compare, "zh-CN") == 0) {
                    target = this.formatString(targetObj[secondSortTitle], commaReg);
                    compare = this.formatString(compareObj[secondSortTitle], commaReg);
                    return isAsc ? target.localeCompare(compare, "zh-CN") : compare.localeCompare(target, "zh-CN");
                } else {
                    return target.localeCompare(compare, "zh-CN");
                }
            }
        });

        return new Set(result);
    }
}

export default AMCFundSorter;
